<template lang="pug">
  select-box(v-model="selected" :data="paymentMethods" @input="update")
  //.payment-switch-container
    .brand-bordered.payment-switch-button.is-thin.p-2(:class="{ 'is-active': selected === 'cash' }")
        b-radio(v-model="selected" :native-value="PAYMENT_TYPES.CASH" @input="update")
            span {{$t('payment_types.cash')}}
    .brand-bordered.payment-switch-button.is-thin.p-2(:class="{ 'is-active': selected === 'transfer' }")
        b-radio(v-model="selected" :native-value="PAYMENT_TYPES.NON_CASH" @input="update")
            span {{$t('payment_types.non_cash')}}
    
    
    //- .payment-switch-container
    //-   button.button.payment-switch-button(:class="{ 'active': selected === 'cash' }" @click="select('cash')")
    //-     i.fas.fa-money-bill-wave
    //-     span Cash
    //-   button.button.payment-switch-button(:class="{ 'active': selected === 'transfer' }" @click="select('transfer')")
    //-     i.fas.fa-university 
    //-     span Transfer
</template>

<script>
import PAYMENT_TYPES from '../../../constants/paymentTypes'
export default {
  name: 'PaymentTypeSelector',
  props: {
    value: {type: String, default: PAYMENT_TYPES.NON_CASH}
  },
  data() {
    return {
      selected: this.value,
      PAYMENT_TYPES
    }
  },
  computed: {
    paymentMethods() {
      return [
        {
          icon: 'bank-outline',
          title: this.$t('payment_types.non_cash'),
          value: PAYMENT_TYPES.NON_CASH
        },
        {
          icon: 'cash-register',
          title: this.$t('payment_types.cash'),
          value: PAYMENT_TYPES.CASH
        }
      ]
    }
  },
  created() {
    this.selected = this.value || PAYMENT_TYPES.NON_CASH
  },
  methods: {
    update() {
      this.$emit('input', this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-switch-container {
  display: flex;
  width: 100%;

  border-radius: 8px;

  gap: 8px;
}

.payment-switch-button {
  flex: 1;
  margin: 0;
  padding: 8px;

  transition: all 0.3s ease;

  //   &:first-child {
  //     border-right: 1px solid rgba(0, 0, 0, 0.1);
  //   }

  //   i {
  //     font-size: 18px;
  //   }

  //   span {
  //     font-weight: 500;
  //   }

  &.active {
    background-color: #4caf50;
    color: white;
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.2);
  }
}
</style>
